import { jsxs, jsx } from 'react/jsx-runtime';
import { useResourceDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { getResourceNamePlaceholder } from '../../../../utils/getResourceTitle.js';
import { useMemo } from 'react';
import { ResourcePath } from '../../../ResourcePath/ResourcePath.js';
import { useQueryUserInfo } from '../../../../../user/queries/useQueryUserInfo.js';
import AvatarUser from '../../../../../user/components/AvatarUser/AvatarUser.js';
import { useResourcePermissionsByCurrentUser } from '../../../../../resource-detail/components/context/getDisabledActionsReasons.js';
import { BadgePermissionRole } from '../../../../../permission/components/BadgePermissionRole.js';
import { PermissionRole } from '@fabric-app/types/permission';
import { styled } from 'styled-components';
import { cssTextEllipsis } from '@fabric-app/ui/constants/styled-utils';
import { generatePath } from '@fabric-app/utils/url/routing';
import { appRoutes } from '../../../../../app/routing/routes.config.js';
import { getIntegrationConfig } from '../../../../../connections/connections.config.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';

const shouldRenderPathItem = (item, index, pathLength) => {
  return index === 0 || index >= pathLength - 2;
};
const useShouldRenderPathItemBasedOnViewportWidth = () => {
  const { isMobileView, isTabletView } = useResponsive();
  const shouldRenderPathItem2 = useMemo(() => {
    if (isMobileView) {
      return void 0;
    }
    if (isTabletView) {
      const fn2 = (item, index, pathLength) => {
        return index === 0 || index >= pathLength - 2;
      };
      return fn2;
    }
    const fn = (item, index, pathLength) => {
      return index === 0 || index >= pathLength - 5;
    };
    return fn;
  }, [
    isMobileView,
    isTabletView
  ]);
  return shouldRenderPathItem2;
};
const ResourcePathAndName = () => {
  const { resource } = useResourceDataContextSafe();
  const { data: user } = useQueryUserInfo();
  const path = useMemo(() => {
    const resourceRootId = resource.root?.folder.id;
    const res = resource.ancestors.map((item) => {
      return {
        id: item.id,
        name: item.name,
        onClick: (e) => {
          e.stopPropagation();
        },
        href: item.id === resourceRootId ? generatePath(appRoutes.space.detail, {
          spaceId: resourceRootId
        }) : generatePath(appRoutes.folder.detail, {
          folderId: item.id
        })
      };
    });
    res.push({
      id: resource.id,
      name: /* @__PURE__ */ jsxs(Name, {
        children: [
          resource.name || getResourceNamePlaceholder(resource),
          resource.extension && /* @__PURE__ */ jsxs("span", {
            style: {
              opacity: 0.7
            },
            children: [
              ".",
              resource.extension
            ]
          })
        ]
      })
    });
    return res;
  }, [
    resource
  ]);
  const isRootOwner = resource.root?.folder.user && resource.root.folder.user.id !== user?.id ? false : true;
  const { userRole } = useResourcePermissionsByCurrentUser(resource);
  const connectionConfig = getIntegrationConfig(resource._meta?.externalData?.provider?.replace("-", "_"));
  return /* @__PURE__ */ jsx(StyledResourcePath, {
    path,
    shouldRenderPathItem,
    startElement: connectionConfig ? /* @__PURE__ */ jsx(connectionConfig.IconPath, {}) : !isRootOwner ? resource?.root?.folder.user && /* @__PURE__ */ jsx(AvatarUser, {
      user: resource.root.folder.user,
      size: 16
    }) : void 0,
    children: resource && userRole !== PermissionRole.OWNER && /* @__PURE__ */ jsx(BadgePermissionRole, {
      role: userRole,
      itemType: "space"
    })
  });
};
const StyledResourcePath = styled(ResourcePath).withConfig({
  displayName: "ResourcePathAndName__StyledResourcePath",
  componentId: "sc-bd098a27-0"
})([
  `flex-wrap:wrap;max-width:100%;width:100%;gap:0.25rem 0.5rem;[data-compacted='true'] + [data-divider='true'] + [data-compacted='true']{display:none;& + [data-divider='true']{display:none;}}[data-path-item]{max-width:calc(100% - 3rem);}`
]);
const Name = styled.span.withConfig({
  displayName: "ResourcePathAndName__Name",
  componentId: "sc-bd098a27-1"
})([
  ``,
  ``
], cssTextEllipsis);

export { ResourcePathAndName, useShouldRenderPathItemBasedOnViewportWidth };
//# sourceMappingURL=ResourcePathAndName.js.map
